import { useCallback } from 'react'
import { NotificationOptions, useNotify } from 'react-admin'

type Options = NotificationOptions

const infoOptions: Options = { type: 'info', multiLine: true }
const errorOptions: Options = { type: 'error', multiLine: true }
const successOptions: Options = { type: 'success', multiLine: true }

const useAlert = () => {
  const notify = useNotify()

  const alertInfo = useCallback(
    (message: string) => notify(message, infoOptions),
    [notify]
  )
  const alertSuccess = useCallback(
    (message: string) => notify(message, successOptions),
    [notify]
  )
  const alertError = useCallback(
    (message: string) => notify(message, errorOptions),
    [notify]
  )

  const alertErrors = useCallback(
    (message: string[]) => {
      const errorMessage = message.join('\n')
      notify(errorMessage, errorOptions)
    },
    [notify]
  )

  return {
    alertInfo,
    alertSuccess,
    alertError,
    alertErrors
  }
}

export default useAlert
